import styled from 'styled-components';
import {
  compose,
  color,
  ColorProps,
  border,
  BorderProps,
  layout,
  LayoutProps,
  typography,
  TypographyProps,
  space,
  SpaceProps
} from 'styled-system';
import { setFormInputStyle } from '../Form.style';

export interface IAutosizeOptions {
  minRows?: number;
  maxRows?: number;
}

export type StyledTextareaProps = React.TextareaHTMLAttributes<
  HTMLTextAreaElement
> &
  LayoutProps &
  BorderProps &
  SpaceProps &
  ColorProps &
  TypographyProps & {
    /**
     * @default false
     * Renders Form.TextArea in disabled state
     * */
    disabled?: boolean;
    /**
     * Renders Form.TextArea in an inValid => error state
     * */
    hasError?: boolean;
    /**
     * @default false
     * Allows textArea to auto size itself based on text content and provided constraints.
     */
    autosize?: boolean | IAutosizeOptions;
    /**
     * @default undefined
     * Provides character limit for counter
     */
    maximum?: number;
  };

export default styled.textarea<StyledTextareaProps>`
  ${({ hasError, theme, autosize }) => `
    box-sizing: border-box;
    min-height: 50px;
    ${autosize ? 'overflow-y: hidden; resize: none;' : 'resize: vertical;'}
    ${setFormInputStyle(hasError, theme)}
  `}
  ${compose(border, typography, layout, color, space)}
` as any;
